module.exports = __webpack_public_path__ + "static/media/LCD-kortit-EN.48d9232b.png";